module.exports = "/_next/static/images/8cd758339a11435f428e0a61703b8481-hands-holding-cards-lg@1x.jpg.webp";